import { Alert, Col, Flex, Row, Space, Tag, theme, Typography } from 'antd';
import { InfoCard } from './InfoCard';
import { formatCurrency } from 'Utils/numberUtils';
import { VEHICLE_FIELDS } from '@features/vehicles/constants/vehicleFields';
import { CLIENT_FIELDS } from '@features/clients/constants/clientFields';
import { MONEY_COLOR } from '@shared/constants/colors';
import { TAKER_STEP_CONFIG, VEHICLE_STEP_CONFIG } from 'Pages/QuotationPage/constants/stepsConfig';

const { Text } = Typography;

const STEP_INNER_SPACING = 24;

export const ConfirmationStep = ({ vehicle, taker, isExternal }) => {
  const { token: themeToken } = theme.useToken();

  const isCompany = taker.documentType === 'NIT';

  return (
    <Flex gap={STEP_INNER_SPACING} vertical>
      <Row gutter={[STEP_INNER_SPACING, STEP_INNER_SPACING]}>
        <Col flex='1 0 24em'>
          <InfoCard
            icon={VEHICLE_STEP_CONFIG.icon}
            title={<Space>
              {VEHICLE_STEP_CONFIG.title}
              <Tag color={vehicle[VEHICLE_FIELDS.IS_NEW] ? 'blue' : 'default'} style={{ margin: 0 }}>
                {vehicle[VEHICLE_FIELDS.IS_NEW] ? 'Nuevo' : 'Usado'}
              </Tag>
            </Space>}
            record={vehicle}
            items={[
              {
                label: 'Placa',
                field: VEHICLE_FIELDS.PLATE,
              },
              {
                label: 'Código Fasecolda',
                field: VEHICLE_FIELDS.FASECOLDA_CODE,
              },
              {
                label: 'Marca',
                field: VEHICLE_FIELDS.BRAND,
              },
              {
                label: 'Modelo',
                field: VEHICLE_FIELDS.MODEL,
              },
              {
                label: 'Referencia',
                field: VEHICLE_FIELDS.LINE,
              },
              {
                label: 'Clase',
                field: VEHICLE_FIELDS.CLASS,
              },
              {
                label: 'Ciudad de circulación',
                field: VEHICLE_FIELDS.CIRCULATION_CITY_NAME,
              },
              {
                label: 'Tipo de servicio',
                field: VEHICLE_FIELDS.SERVICE,
              },
              {
                label: 'Valor Asegurado',
                field: VEHICLE_FIELDS.INSURED_VALUE,
                render: (value) => <Text strong style={{ color: MONEY_COLOR }}>{formatCurrency(value)}</Text>,
              },
              {
                label: 'Valor Accesorios',
                field: VEHICLE_FIELDS.ACCESSORIES_VALUE,
                render: (value) => formatCurrency(value),
              },
              {
                label: '¿Es utilitario?',
                field: VEHICLE_FIELDS.IS_UTILITARIAN,
                render: (value) => value ? 'Sí' : 'No',
              },
            ]}
          />
        </Col>
        <Col flex='1 0 24em'>
          <InfoCard
            icon={TAKER_STEP_CONFIG.icon}
            title={TAKER_STEP_CONFIG.title}
            record={taker}
            items={[
              {
                label: 'Tipo de documento',
                field: CLIENT_FIELDS.DOCUMENT_TYPE,
              },
              {
                label: 'Número de documento',
                field: CLIENT_FIELDS.DOCUMENT_NUMBER,
              },
              {
                label: isCompany ? 'Razón social' : 'Nombres',
                field: CLIENT_FIELDS.FIRST_NAME,
              },
              !isCompany && {
                label: 'Apellidos',
                field: CLIENT_FIELDS.LAST_NAME,
              },
              {
                label: `Fecha de ${isCompany ? 'constitución' : 'nacimiento'}`,
                field: CLIENT_FIELDS.DATE_OF_BIRTH,
              },
              !isCompany && {
                label: 'Género',
                field: CLIENT_FIELDS.GENDER,
              },
              {
                label: 'Número de celular',
                field: CLIENT_FIELDS.PHONE_NUMBER,
              },
              {
                label: 'Correo electrónico',
                field: CLIENT_FIELDS.EMAIL,
              },
            ].filter(Boolean)}
          />
        </Col>
      </Row>
      <Alert
        message={
          <Text strong style={{ color: themeToken.colorInfo }}>
            {isExternal
              ? '¡Todo listo para crear la cotización!'
              : '¡Todo listo para generar las cotizaciones!'
            }
          </Text>
        }
        description={
          isExternal
            ? 'Ya tenemos toda la información. Al continuar, se creará la cotización, será revisada por un asesor y él se pondrá en contacto contigo.'
            : 'Ya tenemos toda la información. Al continuar, verás las mejores opciones de seguros para el vehículo.'
        }
        style={{ textAlign: 'center' }}
      />
    </Flex>
  );
};